import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import { colors } from '@offerzen/pinata-shame'
import EmailIcon from '@offerzen/zenicon/EmailIcon'
import FormErrorMessage from '../FormErrorMessage'
import FormHelpText from '../FormHelpText'
import AccessibleIcon from '../../../CandidateExperience/components/AccessibleIcon'

import styles, { wrapperTheme } from './styles'

const EmailInput = ({ meta, input, className, theme, helpText, onChange, ...props }) => {
  const value = input.value || props.value
  const errored = meta.touched && meta.error

  return (
    <div className={cx(styles.container, className)}>
      <div className={cx(styles.wrapper, wrapperTheme(theme), errored && styles.wrapperError)}>
        <input
          type="email"
          {...input}
          {...props}
          value={value}
          className={styles.input}
          onChange={ev => {
            const handler = input.onChange || onChange
            if (handler) handler(ev.target.value)
          }}
        />

        <div className={styles.icon}>
          <AccessibleIcon icon={EmailIcon} size={18} color={errored ? colors.mandy : colors.grayChateau} />
        </div>
      </div>

      <If condition={helpText && !errored}>
        <FormHelpText text={helpText} />
      </If>

      <If condition={errored}>
        <FormErrorMessage text={meta.error} />
      </If>
    </div>
  )
}

EmailInput.propTypes = {
  meta: PropTypes.object,
  input: PropTypes.object,
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  helpText: PropTypes.string,
  autoFocus: PropTypes.bool,
  tabIndex: PropTypes.string,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'dark', 'tertiary', 'info']),
  className: PropTypes.string,
  onChange: PropTypes.func,
}

EmailInput.defaultProps = {
  meta: {},
  input: {},
  value: '',
  tabIndex: '0',
}

export default EmailInput
